import { c as _c } from "react/compiler-runtime";
import GridColumn from "@/components/common/grid-column/grid-column";
import GridRow from "@/components/common/grid-row/grid-row";
import SuperTitle from "@/components/common/supertitle/supertitle";
import Image from "@/components/common/image/image";
import imageUrl from "@/sanity/utilities/imageUrl";
import { Eligibility as EligibilityType } from "@/sanity/sanity.types";
interface IEligibilityProps {
  data: EligibilityType;
}
const Eligibility = t0 => {
  const $ = _c(17);
  const {
    data
  } = t0;
  const {
    eyebrow,
    heading,
    subheading,
    items
  } = data;
  let t1;
  if ($[0] !== eyebrow) {
    t1 = <SuperTitle>{eyebrow}</SuperTitle>;
    $[0] = eyebrow;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== heading) {
    t2 = <h2 className="max-w-[620px] text-[#373A36] lg:text-center">{heading}</h2>;
    $[2] = heading;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== subheading) {
    t3 = <p className="max-w-[700px] text-[18px] font-medium leading-[29px] text-[#4A4A4A] lg:text-center">{subheading}</p>;
    $[4] = subheading;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <GridColumn className="flex flex-col gap-2"><div className="flex flex-col gap-4 self-stretch lg:items-center">{t1}{t2}{t3}</div></GridColumn>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== items) {
    t5 = items?.map(_temp);
    $[10] = items;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <GridColumn><div className="grid gap-3 lg:grid-cols-2">{t5}</div></GridColumn>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t6) {
    t7 = <GridRow className="flex max-w-[1200px] flex-col items-start !gap-y-12">{t4}{t6}</GridRow>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default Eligibility;
function _temp(item) {
  return <div key={item._key} className="flex gap-4 rounded-[6px] border border-[#D9D8D6] bg-[#FAFAFA] px-8 py-6"><div className="flex size-8 shrink-0 items-center justify-center rounded-xl border border-[#D9D8D6] bg-[#fff]">{item.icon?.asset && <Image src={imageUrl(item.icon.asset).url()} alt={item.title} width={20} height={20} />}</div><div><span className="font-['lora'] text-[17px] font-bold leading-[21px] text-[#005472]">{item.title}</span><p className="mt-2 text-[14px] font-normal leading-[22px] text-[#4A4A4A]">{item.description}</p></div></div>;
}